<template>
  <div class='' :style = "styles" v-show = "fields.length">
    <div style = "float:right;position:relative;">
      <Button @click = "_reset">重置</Button>
      <a v-if="fields.length > 8" style = "margin-left:10px;" href = "javascript:;" @click = "_arrowDown">{{arrowTxt}}<Icon v-if = "arrowDown" type="ios-arrow-up" /><Icon v-else type="ios-arrow-down" /></a>
      <Button style = 'position:absolute;top:56px;left:0px;' type = "primary" @click = "_search">搜索</Button>
      <div style = 'position:absolute;left:-10px;height:90px;top:0;border-left:1px dashed #999;'></div>
    </div>
    <div class = 'form_item' v-for = '(item,index) in fields' :key = "index">
      <mixForm @change = '_change' :fieldData = 'item' style = "margin-bottom:20px;display:block;vertical-align:middle;" />
    </div>
  </div>
</template>
<script>
import mixForm from './dynamicFieldConditionsComponent.vue'
export default {
  props: {
    viewId: String,
    moId: String,
    viewType: String
  },
  data(){
    return {
      fields: [
        
      ],
      formDatas: {

      },
      arrowDown: false
    }
  },
  mounted() {},
  computed: {
    styles(){
      if(this.arrowDown){
        return {
          "height": "auto",
          "min-height": "112px",
          "padding-bottom":"10px",
          "overflow": "hidden"
        }
      }else{
        return {
          // "height": "52px",
          "height": "112px",
          "padding-bottom":"10px",
          "overflow": "hidden"
        }
      }
    },
    arrowTxt(){
      return this.arrowDown? '收起': '展开'
    }
  },
  created(){
    this._getSearchField()
  },
  methods:{
    _makeQuerySql(params){
      let str = ""
      let num = ""
      for(let i in params){
        if(params[i].value||params[i].value === 0){
          if(
            params[i].fieldType == "5"||
            params[i].fieldType == "6"||
            params[i].fieldType == "7"||
            (params[i].fieldType == "20"&&params[i].calcResultType == "6")||
            (params[i].fieldType == "20"&&params[i].calcResultType == "7")
          ){
            num = `${num} & ${i} between ${params[i].value['min']} and ${params[i].value['max']}`
          }else if(params[i].fieldType == "10" || params[i].fieldType == "11"){
            // str = `${str} and ${i} = ${params[i].value}`
            if(params[i].value.length&&params[i].value[0]&&params[i].value[1]){
              str = `${str} and ${i} between ${params[i].value[0]} and ${params[i].value[1]}`
            }
          }else if(params[i].fieldType == "2" || params[i].fieldType == "3" || params[i].fieldType == "4"){
            str = `${str} and ${i} = ${params[i].value}`
          }else{
            str = `${str} and ${i} like ${params[i].value}`
          }
        }
      }
      let pam = "";
      if(num === ""){
        pam = str;
      }else{
        pam = str + "$"+ num;
      }
      return pam
    },
    _arrowDown(){
      this.arrowDown = !this.arrowDown
    },
    _getSearchField(viewId,viewType,moId){
      viewId = viewId || this.viewId
      viewType = viewType || this.viewType
      moId = moId || this.moId
      this.$http.get('/scmd/fields/getSearchFieldList?viewId='+viewId+'&moId='+moId+'&viewType='+viewType).then(({data}) => {
        console.log(data)
        if(data.returnCode == 0){
          this.fields = data.beans
        }
      })
    },
    _search(){
      this.$emit('change',this.formDatas)
    },
    _change(val){
      console.log(val)
      this.formDatas[val.fieldCname] = {
        ...val
      }
      // this.$emit('change',this.formDatas)
    },
    _reset(){
      this.fields = []
      this.formDatas = {}
      this._getSearchField()
      this.$emit('change',{})
    },
    _resetSync(viewId,viewType,moId){
      console.log(viewId,viewType,moId)
      this.fields = []
      this.formDatas = {}
      this._getSearchField(viewId,viewType,moId)
    }
  },
  components: {
    mixForm
  }
}
</script>
<style scoped lang = 'less'>
.form_item{
  display: inline-block;
  /* width:220px; */
  width:calc(25% - 37px);
  margin-right:10px;
  vertical-align: top;
}
/deep/ .ivu-input{
  padding-right: 30px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>